import _ from 'lodash';
import globalStore from '$$globalStore';

export default function (taskId, ganttId, changedResources = []) {
  if (!taskId) {
    throw 'Task id is not provided for preparing task resources';
  }

  if (!ganttId) {
    throw 'Gantt id is not provided for preparing task resources';
  }

  const addedResources = changedResources.filter(r => r.action === 'insert');
  const taskResources = [];

  addedResources.forEach(resource => {
    if (_.isNil(resource.value)) {
      throw 'Resource value is not provided for preparing task resources';
    }

    const customDays = [];

    resource.customEstimation?.forEach(changedDay => {
      if (changedDay.action === 'insert') {
        customDays.push({
          day_part: changedDay.day_part,
          estimation: changedDay.estimation,
        });
      }
    });

    taskResources.push({
      id: null,
      resource_id: resource.resource_id,
      task_id: taskId,
      value: resource.value,
      custom_days: customDays,
      resource_tasks_id: null,
    });
  });

  const oldTaskResources = globalStore.getters['tasksModel/getResourcesForTask'](+ganttId, taskId) || [];

  oldTaskResources.forEach(resource => {
    const changedResource = changedResources.find(r => resource.resource_id === r.resource_id);

    if (changedResource && changedResource.action === 'delete') {
      return;
    }

    if (changedResource && changedResource.action === 'update') {
      let customDays = _.differenceBy(resource.custom_days, changedResource.customEstimation, 'day_part');
      let needReset = false;

      changedResource.customEstimation?.forEach(changedDay => {
        if (!needReset && changedDay.action === 'insert') {
          customDays.push({
            day_part: changedDay.day_part,
            estimation: changedDay.estimation,
          });
        }

        if (changedDay.action === 'delete') {
          needReset = true;
          customDays = []; // remove all resource custom days if 'delete' action was found
        }
      });

      taskResources.push({ ...resource, value: changedResource.value, custom_days: customDays });
    }

    if (!changedResource) {
      taskResources.push({ ...resource });
    }
  });

  return taskResources;
}
